import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  classifications: [],
  categories: [],
  types: [],
  metricUnits: [],
  productListings: [],
  productListing: undefined,
  buyerListings: [],
  buyerListing: undefined,
  specifications: [],
  typesRegistration: [],
};

const ProductSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setClassifications: (state, action) => {
      state.classifications = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setTypes: (state, action) => {
      state.types = action.payload;
    },
    setMetricUnits: (state, action) => {
      state.metricUnits = action.payload;
    },
    setProductListings: (state, action) => {
      state.productListings = action.payload;
    },
    setProductListing: (state, action) => {
      state.productListing = action.payload;
    },
    setBuyerListings: (state, action) => {
      state.buyerListings = action.payload;
    },
    setBuyerListing: (state, action) => {
      state.buyerListing = action.payload;
    },
    setSpecifications: (state, action) => {
      state.specifications = action.payload;
    },
    setTypesRegistration: (state, action) => {
      state.typesRegistration = action.payload;
    },
    resetProductSlice: () => initialState,
  },
});

export const {
  setClassifications,
  setCategories,
  setTypes,
  setMetricUnits,
  setProductListings,
  setProductListing,
  setBuyerListings,
  setBuyerListing,
  setSpecifications,
  setTypesRegistration,
  resetProductSlice,
} = ProductSlice.actions;

export default ProductSlice.reducer;
